<template>
  <div v-if="'options' in item && item.options.length > 0">
    <div class="d-block">
      <span class="font-weight-bold">
        {{ item.key }}
      </span>
    </div>

    <template v-if="item.component === 'inline'">
      <div class="pt-3">
        <div class="d-inline-block mr-1 mb-1" v-for="(opt, i) in item.options" :key="i">
          <custom-pill :value="opt.key" :status="opt.value" :fixedWidth="opt.fixedWidth"></custom-pill>
        </div>
      </div>
    </template>

    <template v-if="item.component === 'flex'">
      <div v-for="(opt, i) in item.options" v-bind:key="i">
        <div class="d-flex">
          <div class="py-2 px-3 mr-auto">
            <span class="align-middle">{{ opt.key }}</span>
          </div>
          <div class="py-2 px-3">
            <b-form-radio class="align-middle d-inline" v-model="opt.value" :value="true" disabled>
              <span class="align-middle feature-radio-label">
                {{ opt.value ? $t('common.present') : $t('common.absent') }}
              </span>
              <template v-if="opt.badge">
                <b-badge pill :class="['badge-' + opt.badge_class, 'ml-2', 'align-middle']">
                  <span class="align-middle">{{ $t('common.' + opt.badge_class) }}</span>
                </b-badge>
              </template>
            </b-form-radio>
          </div>
        </div>
        <div class="py-2 px-3 align-right text-right" v-if="opt.value && opt.legend && opt.legendValue">
          <small class="text-muted">{{ opt.legend }}: {{ opt.legendValue }}</small>
        </div>
        <div v-if="'border' in opt && opt.border" class="my-1 border-bottom"></div>
      </div>
    </template>

    <template>
      <div class="d-block py-4" v-if="item.component === 'table'">
        <b-table
          striped
          hover
          :items="item.fields"
          fixed
          class="table-data text-center w-100 mb-0"
          primary-key="id"
        ></b-table>
      </div>
    </template>
  </div>
  <div v-else>
    <template v-if="item.component === 'default'">
      <component v-bind:is="'FlexDataRow'" :name="item.key" :value="item.value"></component>
    </template>

    <template v-if="item.component === 'minMax'">
      <div v-if="item.value.min != null || item.value.max != null">
        <component v-bind:is="'FlexRangeRow'" :name="item.key" :min="item.value.min" :max="item.value.max"></component>
      </div>
    </template>

    <template v-if="item.component === 'CustomSlider'">
      <div v-if="item.value">
        <div class="d-block">
          <span class="font-weight-bold">
            {{ item.key }}
          </span>
        </div>
        <div class="w-100 d-block py-4">
          <component
            v-bind:is="item.component"
            v-model="item.value"
            :min="item.marks.inf"
            :max="item.marks.sup"
            :disabled="true"
            :tooltip="'none'"
            :formatter="item.formatter"
            :css="['vue-slider-custom-label']"
            :marks="[item.marks.inf, item.marks.sup, item.value[0], item.value[1]]"
          ></component>
        </div>
      </div>
    </template>

    <template v-if="item.component === 'radio'">
      <div class="d-flex">
        <div class="pt-1 mr-auto">
          <span class="font-weight-bold">{{ item.key }}</span>
        </div>
        <div>
          <b-form-radio class="align-middle d-inline" v-model="item.value" :value="true" disabled>
            <span class="align-middle feature-radio-label">
              {{ item.value ? $t('common.present') : $t('common.absent') }}
            </span>
          </b-form-radio>
        </div>
      </div>
    </template>

    <template v-if="item.component === 'pill'">
      <div class="d-inline">
        <custom-pill :value="item.key" :status="item.value" :fixedWidth="item.fixedWidth"></custom-pill>
      </div>
    </template>

    <template v-if="item.component === 'flex'">
      <div :class="[item.class === 'd-flex' ? 'ml-auto' : '', 'p-2']">
        <template v-if="item.component === 'default'">
          <span>{{ item.value }}</span>
        </template>
        <template v-else-if="item.component === 'radio'">
          <b-form-radio class="align-middle" v-model="item.value" :value="true" disabled>
            <span class="align-middle feature-radio-label">
              {{ item.value ? $t('common.present') : $t('common.absent') }}
            </span>
          </b-form-radio>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import FlexDataRow from './FlexDataRow.vue'
import FlexRangeRow from './FlexRangeRow.vue'
import CustomPill from '../../components/Lib/CustomPill.vue'
import CustomSlider from '../../components/Lib/CustomSlider.vue'

export default {
  components: {
    CustomSlider,
    CustomPill,
    FlexDataRow,
    FlexRangeRow,
  },

  props: {
    item: {
      type: [Array, Object],
    },
  },
}
</script>

<style lang="scss" scoped>
.badge-optional {
  background-color: var(--gray12);
}

.badge-mandatory {
  background-color: var(--badgePillRequiredColor);
}

/deep/.vue-slider-custom-label {
  font-size: 12px;
  margin-top: 9px;
}

/deep/ .table-data th {
  background-color: var(--primary);
  padding: 5px 10px;
  color: white;
}
</style>
